import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import { Role, Claim } from '@/types/_'
// import perfis from '@/mocks/configperfis'
import { timeout } from '@/utils/common'

@Module({ namespaced: true, name: 'ConfigPerfilStore' })
export default class ConfigPerfilStore extends VuexModule {
  private perfisDefault: Role[] = []
  private perfilDefault: Role = {
    nome: '',
    claims: null,
  }

  public perfis: Role[] = [...this.perfisDefault]
  public perfil: Role = { ...this.perfilDefault }
  public configPerfisTableHeader: any[] = [
    { text: 'Nome do perfil', class: 'table-headers', align: 'left', value: 'nome', sortable: false },
    { text: 'Ações', class: 'table-headers', value: '', align: 'center', sortable: false },
  ]

  public modal: any = {
    createPerfil: false,
    editPerfil: false,
  }

  @Mutation
  setModal(modal: any) {
    this.modal[modal.name] = modal.value
  }

  @Mutation
  setPerfis(value: Role[]) {
    this.perfis = value
  }

  @Mutation
  setPerfil(value: Role) {
    this.perfil = value
  }

  @Mutation
  clearPerfis() {
    this.perfis = [...this.perfisDefault]
  }

  @Mutation
  clearPerfil() {
    this.perfil = { ...this.perfilDefault }
  }

  @Action
  async getPerfis() {
    await timeout(1500)
    this.context.commit('setPerfis', [])
  }
}
